import React, {Component} from "react";
import { TextButton } from "../Buttons/Text/TextButton";

import "./InputFile.css"
export class InputFile extends Component {
    constructor(props) {
        super(props);

        this.inputFile = React.createRef();
    }

    render() {
        return (
            <div className="inputFile">
                <div className="inputFile__container">
                    <input type="file" ref={this.inputFile} accept={this.props.data.accept || ".*"}/>
                </div>
                <div>
                    <TextButton data={{fontSize: "1rem", text: "上傳"}} onClick={this.handleClick}/>
                </div>          
            </div>
        )        
    }

    handleClick = () => {
        this.props.onUploadClick(this.inputFile.current.files);        
    }
}